'use strict';

var $ = require('jquery');

var classNames = {
	introPanel: 'intro-panel',
	accordionHeading: 'accordion-heading',
	expandedText: 'expanded-text'
};

var modifierNames = {
	isExpanded: 'is-expanded'
};

module.exports = {
	init: function () {	
		var $introPanel = $.findByBem(classNames.introPanel);

		if ($introPanel.length === 0) {
			return;
		}

		var $accordionHeading = $.findByBem(classNames.introPanel, classNames.accordionHeading);
		var $expandedText = $.findByBem(classNames.introPanel, classNames.expandedText);
			
		$accordionHeading.off('click.introPanel').on('click.introPanel', function (e) {
			e.preventDefault();
			
			if ($accordionHeading.hasBemClass(classNames.introPanel, classNames.accordionHeading, modifierNames.isExpanded)) {
				$expandedText.slideUp();
				$accordionHeading.removeBemClass(classNames.introPanel, classNames.accordionHeading, modifierNames.isExpanded);
			} else {
				$expandedText.slideDown();
				$accordionHeading.addBemClass(classNames.introPanel, classNames.accordionHeading, modifierNames.isExpanded);				
			}
		});
	}
};